import WarningIcon from '@mui/icons-material/Warning';
import { Trans, useTranslation } from 'react-i18next';
import { Navigate, useLocation } from "react-router-dom";

type PropsData = {
    commerceName: string | undefined,
    amount: string,
    reference: string,
  }


function BankTrasferInfo() {
  const { t } = useTranslation();
  const location = useLocation();
  const state = location.state as PropsData | undefined;

  if (!state) {
    return <Navigate to="/*" replace />;
  }

  return (
      <div className="payment-container">
      <h1>
        {t('bankTransferInfo.title')}
      </h1>

  <div className="transfer-box">
    <h2>{t('bankTransferInfo.subtitle')}</h2>

    <div className="transfer-data">
      <p><strong>{t('bankTransferInfo.bank')}</strong> {t('transferModal.bankName')}</p>
      <p><strong>{t('transferModal.cbuLabel')}</strong> 3220001812019036780049</p>
      <p><strong>{t('transferModal.aliasLabel')}</strong> PAYPUNTA.BINCO</p>
      <p><strong>{t('transferModal.accountLabel')}</strong> Cuenta Corriente 1-1903678/4</p>
      <p><strong>{t('transferModal.currencyLabel')}</strong> {t('transferModal.currencyValue')}</p>
      <p><strong>{t('transferModal.branchLabel')}</strong> 1</p>
      <p><strong>{t('transferModal.cuitLabel')}</strong> 30718559347</p>
      <p><strong>{t('transferModal.reference')}</strong> {state?.commerceName}{state?.reference }</p>
    </div>
    <div className='warning-title'><WarningIcon sx={{ mr: 1, fontSize: 20 }} /><h3>Importante</h3></div>
    <div className="important-box">
      <Trans i18nKey="bankTransferInfo.warning" components={{ strong: <strong /> }} />
      <div className='final-message'>
        {t('transferModal.instructions')}<br></br>
        <Trans i18nKey="transferModal.warning" components={{ strong: <strong /> }} />
      </div>
    </div>

    <h3>{t('transferModal.totalToPay')}</h3>
    <div className="amount-box">
      {state?.amount}
    </div>
    
  </div>
</div>

    );
}

export default BankTrasferInfo;
 